import reportsReducer from "./ReportsReducer";
import settingsReducer from "./SettingsReducer";
import spacesReducer from "./SpacesReducer";
import tagsReducer from "./TagsReducer";
import userReducer from "./UserReducer";

const rootReducer = {
  user: userReducer,
  settings: settingsReducer,
  spaces: spacesReducer,
  tags: tagsReducer,
  reports: reportsReducer,
};

export default rootReducer;
